module.exports = __webpack_public_path__ + "static/img_shadow-605473f9d70bd471f1ce61552c9cd133.png";